// extracted by mini-css-extract-plugin
export default {"main":"MobileView_main__cN6Hu","main_two":"MobileView_main_two__3uMBX"};